// csrfService, is independent of axiosInstance, and use to fetch the csrf token for POST, PUT, PATCH, DELETE requests
import axios from "axios";
import { PORTAL_API_PATH } from "../config/configs";
import { interceptorRequestBody, interceptorResponseBody, interceptorResponseBodyError } from "./common";

const csrfApiService = axios.create({
  withCredentials: true,
  baseURL: PORTAL_API_PATH,
});

// Add a request interceptor
csrfApiService.interceptors.request.use(
  async (config) => {
    return interceptorRequestBody(config);
  },
  (error) => Promise.reject(error)
);

// Response interceptor for any errors
csrfApiService.interceptors.response.use(
  (response) => {
      return interceptorResponseBody(response);
    },
  (error) => {
    return interceptorResponseBodyError(error);
  }
);

let csrfToken: string | null = null;

export const fetchCsrfToken = async () => {
  /*
  if (csrfToken) {
    return csrfToken;
  }
    */

  try {
    const response = await csrfApiService.get("/csurf/token");
    csrfToken = response.data.csrfToken;
    return csrfToken;
  } catch (error) {
    console.error("Error fetching CSRF token:", error);
    throw error;
  }
};

export const clearCsrfToken = () => {
  csrfToken = null;
};
